// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__36IM7","content":"LoadingAlert_content__ibFGv"};